import { Card } from '@pilot-hub/ui'
import { useAuth } from '@pilot-hub/auth'
import { Users } from 'lucide-react'
import { useEinsatzTrupps, TRUPP_TYP_LABEL } from '../hooks/useEinsatzTrupps'

/** Unauffällige Info „Mein Trupp“: nur sichtbar, wenn der angemeldete Benutzer im Einsatz in einem Trupp ist. */
export function MeinTrupp({ einsatzId }: { einsatzId: number | string | null | undefined }) {
  const { user } = useAuth()
  const { trupps, personen } = useEinsatzTrupps(einsatzId)
  const trupp = trupps.find(t => user && t.mitglieder.includes(Number((user as any).id)))
  if (!trupp) return null
  return (
    <Card className="px-4 py-3" data-testid="mein-trupp">
      <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
        <Users className="h-4 w-4 shrink-0 text-sky-400" />
        <span className="text-xs uppercase tracking-wide text-dark-text-muted">Mein&nbsp;Trupp</span>
        <span className="font-semibold text-dark-text">{trupp.name}</span>
        <span className="text-sm text-dark-text-muted">· {TRUPP_TYP_LABEL[trupp.typ] ?? trupp.typ}</span>
      </div>
      <ul className="mt-2 flex flex-col gap-1 sm:flex-row sm:flex-wrap sm:gap-x-5">
        {[...trupp.mitglieder].sort((a, b) => (b === trupp.fuehrerId ? 1 : 0) - (a === trupp.fuehrerId ? 1 : 0)).map(id => {
          const p = personen.get(id)
          return (
            <li key={id} className="flex items-center gap-2 text-sm text-dark-text" data-testid="mein-trupp-mitglied">
              <span>{p?.name ?? `Benutzer ${id}`}</span>
              {id === trupp.fuehrerId && <span className="rounded bg-primary-600/25 px-1.5 py-0.5 text-[11px] font-semibold text-primary-200" title="Truppführer">TF</span>}
              {p?.fahrzeug && <span className="text-xs text-dark-text-muted">{p.fahrzeug}</span>}
            </li>
          )
        })}
      </ul>
    </Card>
  )
}
